// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useQuery } from '@tanstack/react-query';
import { getFederatedDomains } from '../services/userService';
import { useSharedSession } from '../auth/useSharedSession';

export interface FederatedDomainsView {
  /** Lower-cased email domains whose users sign in with their company account. */
  domains: string[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * The organization's company sign-in domains (`GET /api/v1/users/federated/domains`),
 * so the Add user form can pick a federated or local account from the email
 * before anything is submitted. Waits for the org like `useRoleCatalog`.
 */
export function useFederatedDomains(): FederatedDomainsView {
  const { organizationId } = useSharedSession();
  const query = useQuery({
    queryKey: ['admin-center', 'federated-domains', organizationId],
    queryFn: getFederatedDomains,
    enabled: !!organizationId,
  });
  return {
    domains: (query.data ?? []).map(d => d.toLowerCase()),
    isLoading: !!organizationId && query.isPending,
    isError: query.isError,
  };
}
